// extracted by mini-css-extract-plugin
module.exports = {"modalDisclaimer":"modal-disclaimer_modalDisclaimer__3lDrl","icon":"modal-disclaimer_icon__1GwIZ","message":"modal-disclaimer_message__2eUdY"};